import { css, cx } from 'linaria';
import { HighlightIcon } from 'components/icons/HighlightIcon';
import { buttonReset } from 'components/buttons/button-reset';
import { tagBase } from './tags';
const highlightWrapper = "h189afap";
export function HighlightsTag({
  count,
  margin
}) {
  const className = cx(highlightWrapper, buttonReset, tagBase);
  return <div className={className} style={{
    margin
  }}>
      <HighlightIcon />
      <span>{count}</span>
    </div>;
}

require("./tag-highlights.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./tag-highlights.js");